import { render, staticRenderFns } from "./CoCardBillingAddress.vue?vue&type=template&id=52a3a13b&scoped=true&"
import script from "./CoCardBillingAddress.vue?vue&type=script&lang=ts&"
export * from "./CoCardBillingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3a13b",
  null
  
)

export default component.exports